// dependencies imports ⇒
import React, { useEffect, useState } from "react";
import swal from "sweetalert";
// assets and scss imports ⇒
import "./raiseInvoice.scss";
// project file imports(UI components) ⇒
import PaymentSummary from "./PaymentSummary";
import PatientDetails from "./PatientDetails";
import ConsultationDetails from "./ConsultationDetails";
import RaiseInvoiceHeader from "./RaiseInvoiceHeader";
import RaiseInvoiceFooter from "./RaiseInvoiceFooter";
import PaymentMenthods from "./PaymentMethods";
import MarkCheckInSuccessModal from "../DoctorDashboard/modal-mark-check-in-success";
import DocumentContainer from "../UI Component/DocumentViewer/DocumentCotainer";
import RaiseInvoicePDFView from "../RaiseInvoicePDFView";
import PendingAmountContainer from "./PendingAmountContainer";
import CustomToggleButton from "../common/CustomToggleButton/indev";
// const file imports(helper methods, etc) ⇒
import {
  DEFAULT_PROCEDURE_DETAILS,
  PAYMENT_DETAILS,
  PAYMENT_OPTIONS,
} from "./constants";
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";
import {
  ADD_MULTIPLE_PAYMENTS,
  EDIT_RESOURCE_INVOICE,
  GET_EDIT_RECEIPT_DETAILS_BY_ID,
  GET_MULTIPLE_PAYMENT_LIST,
  GET_PROCEDURE_DETAILS_BY_ID,
  GET_RECEIPT_DETAILS_BY_ID,
  GET_RESOURCE_PROCEDURE_LIST,
  RAISE_RESOURCE_INVOICE,
} from "./RaiseInvoiceAPIHandler/apiConstants";
import Loader from "../UI Component/Loader/Loader";
import { C2CConsole } from "../../Util/Helper/C2CConsole";
import {
  convertToBoolean,
  getPaidAmountRefund,
  getValueUpto2DecimalPlaces,
} from "./helper";
import { c2cGetApiHandler, c2cPostApiHandler } from "../../Util/c2cApiHandler";
import { USER_TYPE } from "../../Util/constants";
import { useLocation, useHistory } from "react-router-dom";
import useIsMobile from "../../Util/Helper/useIsMobile";

const RaiseInvoice = () => {
  const [loading, setLoading] = useState(false);
  const [consultationOptions, setConsultationOptions] = useState([]);
  const [appointmentDetails, setAppointmentDetails] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState("");
  const [hidePaymentMode, setHidePaymentMethod] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [discountAtClinic, setDiscountAtClinic] = useState(0);
  const [appntPayTransId, setAppntPayTransId] = useState(null);
  const [referenceId, setReferenceId] = useState("");
  const [totalRefund, setTotalRefund] = useState(0);
  const [procedureDetails, setProcedureDetails] = useState([]);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [invoiceUrl, setInvoiceUrl] = useState("");
  const [completionTime, setCompletionTime] = useState(null);
  const [showSuccessMarkModal, setSuccessMarkModal] = useState(false);
  const [fileDetails, setFileDetails] = useState({
    fileURL: "",
    fileName: "Invoice for Your Connect2Clinic appointment",
    fileType: ".pdf",
  });
  const [documentShow, setDocumentShow] = useState(false);
  // new--->

  const [totalPendingAmount, setTotalPendingAmount] = useState(0);
  const [totalConsultationFees, setTotalConsultationFees] = useState(0);
  const [totalAmountPaid, setTotalAmountPaid] = useState(0);
  const [totalFees, setTotalFees] = useState(0);
  const [multiplePaymentList, setMultiplePaymentList] = useState([]);
  const [hasPartialAmount, setHasPartialAmount] = useState(false);
  const [patientDetails, setPatientDetails] = useState({});
  const [isRemark, setIsRemark] = useState(false);
  const [remarkValue, setRemarkValue] = useState("");
  const [totalPaidPartialAmount, setTotalPaidPartialAmount] = useState("");
  const [
    totalPartialAmountWithoutConvenience,
    setTotalPartialAmountWithoutConvenience,
  ] = useState("");
  const [totalPaidFullAmount, setTotalPaidFullAmount] = useState("");
  const [totalGST, setTotalGST] = useState("");
  const [totalConvenience, setTotalConvenience] = useState("");
  const [referredBy, setReferredBy] = useState("");
  const [showReceiptPreview, setShowReceiptPreview] = useState(false);
  const [isPendingView, setIsPendingView] = useState(false);
  const [pdfReceiptData, setPdfReceiptData] = useState({});
  const [raiseInvoiceDrawer, setShowRaiseInvoiceDrawer] = useState(false);
  const [disconnectWebSocket, setDisconnectWebSocket] = useState(false);
  const [totalCustomGst, setTotalCustomGst] = useState("");
  const [deletedPaymentList, setDeletedPaymentList] = useState([]);
  let isMobile = useIsMobile();

  const location = useLocation();
  const history = useHistory();

  const doctor_id = location.state.doctor_id;
  const appointment_id = location.state.appointment_id;
  const edit_receipt = location.state.edit_receipt;
  const order_id = location.state.order_id;
  const appointment = location.state.appointment;
  const user_id = location.state.user_id;
  const clinic_id = location.state.clinic_id;
  const staff_id = location.state.staff_id;
  const user_type = location.state.user_type;

  // const declarations ⇒

  const clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
  const staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);
  const isStaff = localStorage.getItem(LOCALSTORAGEKEY.USER_TYPE);
  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const userType = localStorage.getItem(LOCALSTORAGEKEY.USER_TYPE);

  // let or var declarations ⇒
  let isCompleted =
    appointment?.appointment_status?.toLowerCase() === "completed";

  // life cycle methods ⇒

  useEffect(() => {
    handleReset();
    // if (openView) {
    setShowRaiseInvoiceDrawer(true);
    setPaymentMethod("");
    setProcedureDetails([]);
    getResourceProcedureListAPICall();
    if (edit_receipt) {
      getEditReceiptDetailsByIdAPICall();
    } else {
      getReceiptDetailsByIdAPICall();
    }
    // }
  }, []); //openView

  useEffect(() => {
    // if (openView) {
    let calculatedAmount = multiplePaymentList.reduce(
      (a, v) =>
        a +
        (!v.isSave &&
        v.payment_method !== "" &&
        v.amount &&
        v.payment_method !== "Online Via C2C"
          ? Number(v.amount)
          : 0),
      0
    );
    let filterData = multiplePaymentList.filter(
      (elem) => elem.payment_method !== "Online Via C2C"
    );
    let disableSub = filterData.some(
      (tr) =>
        (tr.payment_method === "" && tr.amount >= 0 && tr.amount !== "") ||
        (tr.payment_method !== "" && (tr.amount <= 0 || tr.amount === ""))
    );
    let isPaymentListEmpty = multiplePaymentList.every((tr) => tr.isSave);

    setDisableSubmit(
      (!isPaymentListEmpty &&
        +calculatedAmount >
          parseFloat(
            (+totalPendingAmount > 0 ? +totalPendingAmount : 0).toFixed(2)
          )) ||
        disableSub
    );
    // }
  }, [multiplePaymentList, totalFees, totalPendingAmount]); //openView,

  // API Calls ⇒

  const getMultiplePaymentListAPICall = (original_appointments) => {
    let filterAppointmentIds = [];
    let onlineViaC2C = [];

    let api = GET_MULTIPLE_PAYMENT_LIST + appointment_id;
    const multiplePaymentResponse = c2cGetApiHandler(api);
    multiplePaymentResponse.then(([res, err]) => {
      if (!err && res?.data?.statusCode == 200) {
        let paymentList =
          res?.data?.data?.multiple_payment_method_details?.filter(
            (ele) => ele.payment_method !== "Refund"
          );
        paymentList.forEach((payment) => (payment["isSave"] = true));
        if (paymentList?.length > 0) {
          setTotalAmountPaid(
            paymentList.reduce((a, v) => a + (v?.amount ?? 0), 0)
          );
        }
        paymentList.forEach((data) => {
          data["specify_other"] =
            data?.payment_method === "Online Via C2C"
              ? false
              : PAYMENT_OPTIONS?.filter(
                  (option) => option.value === data?.payment_method
                )?.length > 0
              ? false
              : true;
        });
        let arr = [];

        // calculation on paid and pending
        let amount = paymentList.reduce(
          (a, v) =>
            a + (v.payment_method !== "Online Via C2C" ? Number(v.amount) : 0),
          0
        );
        let remainingAmount = amount;
        original_appointments.forEach((app) => {
          if (
            app?.partial_amount > 0 ||
            app?.payment_method?.toLowerCase() !== "online"
          ) {
            if (app?.partial_amount > 0) {
              let partial_remaining_amount = (
                Number(app?.final_amount_in_rupees) -
                Number(app?.total_paid_partial_amount)
              ).toFixed(2);
              app["paid_amount"] =
                remainingAmount > partial_remaining_amount
                  ? getValueUpto2DecimalPlaces(
                      Number(app?.final_amount_in_rupees)
                    )
                  : remainingAmount > 0
                  ? getValueUpto2DecimalPlaces(
                      Number(remainingAmount) +
                        Number(app?.total_paid_partial_amount)
                    )
                  : getValueUpto2DecimalPlaces(
                      Number(app?.total_paid_partial_amount)
                    );
              app["pending_amount"] =
                remainingAmount > partial_remaining_amount
                  ? 0
                  : getValueUpto2DecimalPlaces(
                      Math.abs(remainingAmount - partial_remaining_amount)
                    );
              remainingAmount =
                remainingAmount > partial_remaining_amount
                  ? Math.abs(remainingAmount - partial_remaining_amount)
                  : 0;
            } else {
              app["paid_amount"] =
                remainingAmount > app?.final_amount_in_rupees
                  ? getValueUpto2DecimalPlaces(
                      Number(app?.final_amount_in_rupees)
                    )
                  : getValueUpto2DecimalPlaces(remainingAmount);
              app["pending_amount"] =
                remainingAmount > app?.final_amount_in_rupees
                  ? 0
                  : getValueUpto2DecimalPlaces(
                      Math.abs(
                        remainingAmount - Number(app?.final_amount_in_rupees)
                      )
                    );
              remainingAmount =
                remainingAmount > app?.final_amount_in_rupees
                  ? Math.abs(
                      remainingAmount - Number(app?.final_amount_in_rupees)
                    )
                  : 0;
            }
          } else {
            app["paid_amount"] = app?.paid_amount
              ? getValueUpto2DecimalPlaces(Number(app?.paid_amount))
              : getValueUpto2DecimalPlaces(Number(app?.final_amount_in_rupees));
            app["pending_amount"] = 0;
          }
        });
        setAppointmentDetails([...original_appointments]);

        original_appointments.forEach((data) => {
          if (data.booking_id) {
            if (
              !filterAppointmentIds?.includes(data.booking_id) &&
              data?.payment_method?.toLowerCase() === "online"
            ) {
              filterAppointmentIds.push(data.booking_id);
            }
          } else {
            if (data?.payment_method?.toLowerCase() === "online") {
              let amoutPaid =
                Number(data?.total_paid_partial_amount) > 0
                  ? getValueUpto2DecimalPlaces(
                      Number(data?.total_paid_partial_amount)
                    )
                  : getValueUpto2DecimalPlaces(Number(data?.paid_amount));
              let obj = {
                amount: getValueUpto2DecimalPlaces(Number(amoutPaid)),
                payment_method: "Online Via C2C",
                transaction_id: data?.transaction_id,
                specify_other: false,
                isOnline: true,
              };
              onlineViaC2C.push(obj);
            }
          }
        });

        if (filterAppointmentIds?.length > 0) {
          filterAppointmentIds.forEach((id) => {
            let filteredAppointment = original_appointments.filter(
              (data) => data?.booking_id === id
            );
            if (filteredAppointment?.length > 0) {
              let amountPaidByOnline = filteredAppointment.reduce(
                (a, v) =>
                  a +
                  (Number(v?.total_paid_partial_amount) > 0
                    ? getValueUpto2DecimalPlaces(
                        Number(v?.total_paid_partial_amount)
                      )
                    : getValueUpto2DecimalPlaces(Number(v?.paid_amount))),
                0
              );
              let obj = {
                amount: getValueUpto2DecimalPlaces(Number(amountPaidByOnline)),
                payment_method: "Online Via C2C",
                transaction_id: filteredAppointment[0].transaction_id,
                specify_other: false,
                count: filteredAppointment?.length,
                isOnline: true,
              };
              onlineViaC2C.push(obj);
            }
          });
        }
        let newPaymentList = [...onlineViaC2C, ...paymentList];
        if (onlineViaC2C?.length > 0) {
          setMultiplePaymentList(
            paymentList?.length > 0
              ? newPaymentList?.length > 0
                ? [...newPaymentList]
                : [{ ...PAYMENT_DETAILS }]
              : onlineViaC2C?.length > 0
              ? [...onlineViaC2C]
              : [{ ...PAYMENT_DETAILS }]
          );
        } else {
          setMultiplePaymentList(
            paymentList?.length > 0 ? paymentList : [{ ...PAYMENT_DETAILS }]
          );
        }
      } else {
        C2CConsole.log("error while getting payment methods");
      }
    });
  };

  const addMultiplePaymentAPICall = () => {
    setLoading(true);
    let procedureList = [];
    let procedureListString = "";
    if (appointmentDetails?.length > 0) {
      appointmentDetails.forEach((data) => {
        if (data?.procedure_name) {
          procedureList.push(data?.procedure_name);
        } else {
          let consultationType =
            data?.consultation_type === "followup"
              ? "in-clinic followup"
              : data?.consultation_type === "regular"
              ? "in-clinic regular"
              : data?.consultation_type;

          if (consultationType) {
            procedureList.push(consultationType);
          }
        }
      });
    }
    if (procedureDetails?.length > 0) {
      procedureDetails.forEach((data) => {
        if (data?.procedure_name) {
          procedureList.push(data?.procedure_name);
        } else {
          let consultationType =
            data?.consultation_name === "followup"
              ? "in-clinic followup"
              : data?.consultation_name === "regular"
              ? "in-clinic regular"
              : data?.consultation_name;

          if (consultationType) {
            procedureList.push(consultationType);
          }
        }
      });
    }

    if (procedureList?.length > 0) {
      procedureListString = procedureList.join();
    }
    let refundAmount = getPaidAmountRefund(
      totalAmountPaid,
      totalFees,
      totalPaidPartialAmount,
      appointmentDetails
    );
    let api = ADD_MULTIPLE_PAYMENTS + appointment_id;
    let paymentList = multiplePaymentList.filter(
      (payment) =>
        (!payment?.isSave &&
          payment?.payment_method?.trim() !== "" &&
          payment?.amount > 0) ||
        payment?.is_deleted
    );
    // replacing manually given text 'Refund' as 'Refund.' in order to differentiate it with auto refund entry ===>
    paymentList.forEach((ele) => {
      if (ele.payment_method === "Refund") {
        ele.payment_method = "Refund.";
      }
    });
    // <===
    paymentList.push({
      payment_method: "Refund",
      transaction_id: "",
      amount: refundAmount > 0 ? refundAmount : 0,
    });

    paymentList.map(({ amount, transaction_id, payment_method }) => ({
      amount,
      transaction_id,
      payment_method,
    }));

    let payload = {
      multiple_payment_method_details: paymentList,
      user_id: userType === USER_TYPE.STAFF ? staffId : userId,
      user_type: userType,
      procedure_names: procedureListString,
      appointment_id: appointment_id,
      is_remark: isRemark,
      remark_note: remarkValue,
    };
    const multiplePaymentResponse = c2cPostApiHandler(api, payload);
    multiplePaymentResponse.then(([res, err]) => {
      if (!err && res?.data?.statusCode == 200) {
        let paymentList =
          res?.data?.data?.multiple_payment_method_details?.filter(
            (ele) => ele.payment_method !== "Refund"
          );
        paymentList.forEach((payment) => (payment["isSave"] = true));
        if (paymentList?.length > 0) {
          setTotalAmountPaid(
            paymentList.reduce((a, v) => a + (v?.amount ?? 0), 0)
          );
        }
        paymentList.forEach((data) => {
          data["specify_other"] =
            data?.payment_method === "Online Via C2C"
              ? false
              : PAYMENT_OPTIONS?.filter(
                  (option) => option.value === data?.payment_method
                )?.length > 0
              ? false
              : true;
        });
        setMultiplePaymentList(
          paymentList?.length > 0 ? paymentList : [{ ...PAYMENT_DETAILS }]
        );
        generateOrUpdateResourceInvoiceAPICall();
      } else {
        setLoading(false);
      }
    });
  };

  const getResourceProcedureListAPICall = () => {
    let requestPayload = {
      order_id: order_id,
      appointment_id: appointment_id,
    };
    const resourceProceduresResponse = c2cPostApiHandler(
      GET_RESOURCE_PROCEDURE_LIST,
      requestPayload
    );
    resourceProceduresResponse.then(([res, err]) => {
      if (!err && res?.data?.statusCode === 200) {
        let consultationList = res?.data?.consultations;
        let list = [];
        if (consultationList?.length !== 0) {
          let defaultProcedures = [],
            doctorProcedures = [];
          let defaultConsultations = consultationList.filter(
            (consultationRes) =>
              consultationRes.consultation_name !== "Procedure"
          );

          let tempArray = consultationList.filter(
            (consultationRes) =>
              consultationRes.consultation_name === "Procedure"
          );

          if (defaultConsultations?.length !== 0) {
            defaultProcedures = defaultConsultations.map(
              ({
                consultation_type: value,
                consultation_name: label,
                doctor_commission_percentage: doctor_commission_percentage,
              }) => ({
                value,
                label,
                doctor_commission_percentage,
              })
            );
          }

          if (tempArray.length > 0) {
            const newFile = tempArray[0].procedure_list?.map((file) => {
              return { ...file, value: "4" };
            });
            doctorProcedures = newFile.map(
              ({ value, procedure_id: id, procedure_name: label }) => ({
                value,
                id,
                label,
              })
            );
          }
          list = [...defaultProcedures, ...doctorProcedures];
        }
        if (res?.data?.data?.length > 0) {
          let responseList = res?.data?.data;

          const list1 = responseList.map(
            ({
              id,
              procedure_name: label,
              doctor_commission_percentage: doctor_commission_percentage,
              referral_percentage: referral_percentage,
            }) => ({
              value: "4",
              id,
              label,
              doctor_commission_percentage,
              referral_percentage,
            })
          );
          list = [...list, ...list1];
        }
        setConsultationOptions([...list]);
      } else {
        setConsultationOptions([]);
      }
    });
  };

  const getReceiptDetailsByIdAPICall = () => {
    setLoading(true);
    let requestPayload = {
      ...(order_id && { order_id: order_id }),
      appointment_id: appointment_id,
    };
    const receiptDetailsResponse = c2cPostApiHandler(
      GET_RECEIPT_DETAILS_BY_ID,
      requestPayload
    );
    receiptDetailsResponse.then(([res, err]) => {
      if (!err && res?.data?.statusCode == 200) {
        getMultiplePaymentListAPICall(res.data.appointment_details);
        let responseData = res.data.appointment_details;
        if (responseData?.length > 0) {
          responseData.forEach((data) => {
            data.consultation_fee_in_rupees =
              data.consultation_fee_in_rupees ?? 0;
            data.convenience_fee_in_rupees =
              data.convenience_fee_in_rupees ?? 0;
            data.discount_on_consultation_fee_in_rupees =
              data.discount_on_consultation_fee_in_rupees ?? 0;
            data.discount_percent = data.discount_percent ?? 0;
            data.fee_in_rupees = data.fee_in_rupees ?? 0;
            data.refund_in_rupees = 0;
            data.final_amount_in_rupees = data.total_fee_in_rupees ?? 0;
            data.gst_in_rupees = data.gst_in_rupees ?? 0;
            data.custom_gst_in_rupees = data.custom_gst_in_rupees ?? 0;
            data.igst_percent = data.igst_percent ?? 0;
            data.sgst_percent = data.sgst_percent
              ? parseFloat((+data.sgst_percent)?.toFixed(2))
              : 0;
            data.cgst_percent = data.cgst_percent
              ? parseFloat((+data.cgst_percent)?.toFixed(2))
              : 0;
            data.subtotal_in_rupees = data.subtotal_in_rupees ?? 0;
            data.total_fee_in_rupees = data.total_fee_in_rupees ?? 0;
            data["partial_with_convenience_fee"] =
              data?.partial_with_convenience_fee ?? 0;
            data.is_lims_booking = convertToBoolean(data.is_lims_booking);
            data["pending_amount"] = getValueUpto2DecimalPlaces(
              Number(data?.final_amount_in_rupees) -
                Number(data?.paid_amount ? data?.paid_amount : 0)
            );
            data["paid_amount"] = getValueUpto2DecimalPlaces(
              Number(data?.paid_amount ? data?.paid_amount : 0)
            );
          });

          let appIndex = responseData?.findIndex(
            (app) => app?.appointment_id === appointment_id
          );
          if (appIndex > -1) {
            setPatientDetails({ ...responseData[appIndex] });
          }
        }
        let consultation_fees = responseData.reduce(
          (a, v) => a + v.subtotal_in_rupees,
          0
        );

        let discountValue = responseData.reduce(
          (a, v) => a + v.discount_on_consultation_fee_in_rupees,
          0
        );
        let refundValue = responseData.reduce(
          (a, v) => a + v.refund_in_rupees,
          0
        );
        let byCashAndPartialPayedAppointments = responseData.filter(
          (app) =>
            app.partial_amount != 0 ||
            app.payment_method === "Paid at Clinic - By Cash"
        );
        let finalAmount = byCashAndPartialPayedAppointments.reduce(
          (a, v) => a + v.final_amount_in_rupees,
          0
        );

        let discount_percent = responseData.reduce(
          (a, v) => a + v.discount_percent,
          0
        );
        let discount_on_consultation_fee_in_rupees = responseData.reduce(
          (a, v) => a + v.discount_on_consultation_fee_in_rupees,
          0
        );
        let totalCustomGSTValue = responseData.reduce(
          (a, v) => a + (!v.is_deleted ? v.custom_gst_in_rupees : 0),
          0
        );
        setLoading(false);
        setTotalConsultationFees(parseFloat(consultation_fees.toFixed(2)));
        setTotalFees(
          getValueUpto2DecimalPlaces(
            consultation_fees +
              totalCustomGSTValue -
              discountValue -
              refundValue
          )
        );
        setAppointmentDetails(responseData);
        setPaymentMethod(responseData[0]?.payment_method);
        setDiscountAtClinic(discount_on_consultation_fee_in_rupees);
        setInputValue(discount_percent);
        checkPartialAmount(responseData);
        let totalPaidPartialAmt = responseData.reduce(
          (a, v) => a + v.total_paid_partial_amount,
          0
        );
        let totalPartialAmtWithoutConvenience = responseData.reduce(
          (a, v) => a + +v.partial_amount,
          0
        );
        let totalGSTValue = responseData.reduce(
          (a, v) => a + v.gst_in_rupees,
          0
        );
        let totalConvenienceValue = responseData.reduce(
          (a, v) => a + v.convenience_fee_in_rupees,
          0
        );
        let totalPaidFullAmountValue = responseData.reduce(
          (a, v) => a + v.total_fee_in_rupees,
          0
        );
        setTotalPaidPartialAmount(Number(totalPaidPartialAmt));
        setTotalPartialAmountWithoutConvenience(
          Number(totalPartialAmtWithoutConvenience)
        );
        setTotalGST(Number(totalGSTValue)?.toFixed(2));
        setTotalCustomGst(
          getValueUpto2DecimalPlaces(Number(totalCustomGSTValue))
        );
        setTotalConvenience(Number(totalConvenienceValue)?.toFixed(2));
        setTotalPaidFullAmount(Number(totalPaidFullAmountValue));
        checkToHidePaymentMethod(responseData);

        setTotalPendingAmount(
          parseFloat((finalAmount - Number(totalPaidPartialAmt)).toFixed(2))
        );
        setReferredBy("");
      } else {
        setReferredBy("");
        setLoading(false);
      }
    });
  };

  const getEditReceiptDetailsByIdAPICall = () => {
    setLoading(true);
    let requestPayload = {
      ...(order_id && { order_id: order_id }),
      appointment_id: appointment_id,
      doctor_id: doctor_id,
      staff_id: staffId,
    };
    const receiptDetailsResponse = c2cPostApiHandler(
      GET_EDIT_RECEIPT_DETAILS_BY_ID,
      requestPayload
    );
    receiptDetailsResponse.then(([response, error]) => {
      if (!error && response.data.statusCode == 200) {
        let paymentArr = [];
        let data = response.data;

        setIsRemark(data?.is_remark === "True");
        setRemarkValue(data?.remark_note);
        setAppntPayTransId(data?.appointment_payment_transaction_id);
        setPaymentMethod(data?.inclinic_payment_mode);
        setReferenceId(data?.inclinic_payment_reference);
        data.original_appointment_details.forEach((appData) => {
          appData["refund_in_rupees"] = Number(
            appData.is_deleted &&
              (appData.refund_in_rupees === null ||
                appData.refund_in_rupees === 0)
              ? appData.subtotal_in_rupees + appData.custom_gst_in_rupees
              : appData.refund_in_rupees
          ); // added condition for scenario( book appointment through and cancel or mark no show for the same appointment total is breaking)

          appData["final_amount_in_rupees"] = Number(
            appData.final_amount_in_rupees
          );
          appData["is_lims_booking"] = convertToBoolean(
            appData.is_lims_booking
          );
          appData["pending_amount"] = getValueUpto2DecimalPlaces(
            Number(appData?.final_amount_in_rupees) -
              Number(appData?.paid_amount)
          );
          appData["paid_amount"] = getValueUpto2DecimalPlaces(
            Number(appData?.paid_amount)
          );
          appData["sgst_percent"] = appData.sgst_percent
            ? parseFloat((+appData.sgst_percent)?.toFixed(2))
            : 0;
          appData["cgst_percent"] = appData.cgst_percent
            ? parseFloat((+appData.cgst_percent)?.toFixed(2))
            : 0;
        });
        setAppointmentDetails(data.original_appointment_details);
        checkToHidePaymentMethod(
          data.original_appointment_details,
          data.additional_procedure_details
        );
        let procedureList = [];
        if (data?.additional_procedure_details.length !== 0) {
          data.additional_procedure_details.forEach((apd) => {
            procedureList.push({
              ...apd,
              cgst_percent: apd.cgst_percent
                ? parseFloat((+apd.cgst_percent)?.toFixed(2))
                : 0,
              consultation_fee_in_rupees: apd.consultation_fee_in_rupees,
              consultation_name: apd.consultation_name,
              consultation_type: apd.consultation_type,
              convenience_fee_in_rupees: 0,
              discount_on_consultation_fee_in_rupees:
                apd.discount_on_consultation_fee_in_rupees,
              discount_percent: apd.discount_percent,
              fee_in_rupees: apd.fee_in_rupees,
              gst_in_rupees: 0,
              igst_percent: apd.igst_percent ? apd.igst_percent : 0,
              inputValue: 0,
              procedure_id: apd.procedure_id,
              procedure_name: apd.procedure_name,
              doctor_commission_percentage: apd.doctor_commission_percentage,
              referral_percentage: !isCompleted ? apd.referral_percentage : "0",
              sgst_percent: apd.sgst_percent
                ? parseFloat((+apd.sgst_percent)?.toFixed(2))
                : 0,
              subtotal_in_rupees: apd.subtotal_in_rupees,
              total_fee_in_rupees: apd.total_fee_in_rupees,
              refund_in_rupees: apd.refund_in_rupees ? apd.refund_in_rupees : 0,
              final_amount_in_rupees: apd.final_amount_in_rupees,
              paid_amount: apd?.paid_amount
                ? getValueUpto2DecimalPlaces(Number(apd?.paid_amount))
                : 0,
              pending_amount: getValueUpto2DecimalPlaces(
                Number(apd?.final_amount_in_rupees) - Number(apd?.paid_amount)
              ),
              custom_gst_in_rupees: apd.custom_gst_in_rupees ?? 0,
            });
          });
        }

        let original_subtotal = data.original_appointment_details.reduce(
          (a, v) => a + v.subtotal_in_rupees,
          0
        );

        let original_discountValue = data.original_appointment_details.reduce(
          (a, v) => a + v.discount_on_consultation_fee_in_rupees,
          0
        );
        let original_discountPercent = data.original_appointment_details.reduce(
          (a, v) => a + v.discount_percent,
          0
        );
        let original_refundValue = data.original_appointment_details.reduce(
          (a, v) => a + v.refund_in_rupees,
          0
        );

        let total_discount =
          procedureList.reduce(
            (a, v) => a + v.discount_on_consultation_fee_in_rupees,
            0
          ) + original_discountValue;

        setDiscountAtClinic(total_discount);
        setInputValue(
          procedureList.reduce((a, v) => a + v.discount_percent, 0) +
            +original_discountPercent
        );
        let refund = 0;
        procedureList.forEach((pr) => {
          refund += pr.refund_in_rupees ? pr.refund_in_rupees : 0;
        });
        setTotalRefund(Number(refund) + Number(original_refundValue));
        let totalConsultationFee = parseFloat(
          (
            procedureList.reduce((a, v) => a + v.subtotal_in_rupees, 0) +
            Number(original_subtotal)
          ).toFixed(2)
        );

        setTotalConsultationFees(totalConsultationFee);

        let total_refund = Number(refund) + Number(original_refundValue);
        let originalTotalCustomGSTValue =
          data.original_appointment_details.reduce(
            (a, v) => a + (!v.is_deleted ? v.custom_gst_in_rupees : 0),
            0
          );
        let totalCustomGSTValue =
          procedureList.reduce(
            (a, v) => a + (!v.is_deleted ? v.custom_gst_in_rupees : 0),
            0
          ) + originalTotalCustomGSTValue;

        // added this condition for handle  while deleting additional added procedure calculation fix

        let originalTotalCustomGSTValueWithoutCancled =
          data.original_appointment_details.reduce(
            (a, v) => a + v.custom_gst_in_rupees,
            0
          );

        let totalCustomGSTValueWithoutcancled =
          procedureList.reduce((a, v) => a + v.custom_gst_in_rupees, 0) +
          originalTotalCustomGSTValueWithoutCancled;

        setTotalFees(
          getValueUpto2DecimalPlaces(
            totalConsultationFee +
              totalCustomGSTValueWithoutcancled -
              total_discount -
              total_refund
          )
        );

        setProcedureDetails(procedureList);
        checkPartialAmount(data?.original_appointment_details);
        let totalGSTValue = data?.original_appointment_details.reduce(
          (a, v) => a + v.gst_in_rupees,
          0
        );
        let totalConvenienceValue = data?.original_appointment_details.reduce(
          (a, v) => a + v.convenience_fee_in_rupees,
          0
        );
        let totalPaidFullAmountValue =
          data?.original_appointment_details.reduce(
            (a, v) => a + v.total_fee_in_rupees,
            0
          );
        setTotalGST(Number(totalGSTValue)?.toFixed(2));
        setTotalCustomGst(
          getValueUpto2DecimalPlaces(Number(totalCustomGSTValue))
        );
        setTotalConvenience(Number(totalConvenienceValue)?.toFixed(2));
        setTotalPaidFullAmount(totalPaidFullAmountValue);
        let appIndex = data?.original_appointment_details?.findIndex(
          (app) => app?.appointment_id === appointment_id
        );
        if (appIndex > -1) {
          setPatientDetails({
            ...data?.original_appointment_details[appIndex],
          });
        }

        let editedAppointmentData = data?.original_appointment_details?.find(
          (data) => data?.appointment_id === appointment_id
        );
        setReferredBy(editedAppointmentData?.referred_by ?? "");
        let api = GET_MULTIPLE_PAYMENT_LIST + appointment_id;
        const multiplePaymentResponse = c2cGetApiHandler(api);
        multiplePaymentResponse.then(([res, err]) => {
          if (!err && res?.data?.statusCode == 200) {
            let original_appointments = data?.original_appointment_details;
            let added_procedure_appointments = procedureList;
            let filterAppointmentIds = [];
            let onlineViaC2C = [];
            let onlineAmtList = [];
            let paymentList =
              res?.data?.data?.multiple_payment_method_details?.filter(
                (ele) => ele.payment_method !== "Refund"
              );
            paymentList.forEach((payment) => (payment["isSave"] = true));

            if (paymentList?.length > 0) {
              setTotalAmountPaid(
                paymentList.reduce(
                  (a, v) =>
                    a +
                    (v?.payment_method !== "Online Via C2C"
                      ? v?.amount ?? 0
                      : 0),
                  0
                )
              );
            }

            paymentList.forEach((paymentData) => {
              paymentData["specify_other"] =
                paymentData?.payment_method === "Online Via C2C"
                  ? false
                  : PAYMENT_OPTIONS?.filter(
                      (option) => option.value === paymentData?.payment_method
                    )?.length > 0
                  ? false
                  : true;
              paymentData["isOnline"] =
                paymentData?.payment_method === "Online Via C2C";
            });
            paymentList.forEach((data) => {
              if (data.payment_method === "Online Via C2C") {
                data["is_deleted"] = true;
              }
            });

            paymentArr =
              paymentList?.length > 0 ? paymentList : [{ ...PAYMENT_DETAILS }];

            let totalPaidPartialAmt = data?.original_appointment_details.reduce(
              (a, v) => a + v.total_paid_partial_amount,
              0
            );
            let totalPartialAmtWithoutConvenience =
              data?.original_appointment_details.reduce(
                (a, v) => a + +v.partial_amount,
                0
              );
            let amountPayed =
              paymentArr.reduce(
                (a, v) =>
                  a +
                  (v.isSave && v.payment_method !== "Online Via C2C" && v.amount
                    ? Number(v.amount)
                    : 0),
                0
              ) + Number(totalPaidPartialAmt);
            let byCashAndPartialPayedAppointments =
              data.original_appointment_details.filter(
                (app) =>
                  app.partial_amount != 0 ||
                  app.payment_method === "Paid at Clinic - By Cash"
              );
            let caclulatedConsultationFee =
              procedureList.reduce(
                (a, v) => a + Number(v.final_amount_in_rupees),
                0
              ) +
              (byCashAndPartialPayedAppointments?.length > 0
                ? byCashAndPartialPayedAppointments?.reduce(
                    (a, v) => a + Number(v.final_amount_in_rupees),
                    0
                  )
                : 0);
            setTotalPendingAmount(
              parseFloat((caclulatedConsultationFee - amountPayed).toFixed(2))
            );
            setTotalPaidPartialAmount(Number(totalPaidPartialAmt));
            setTotalPartialAmountWithoutConvenience(
              Number(totalPartialAmtWithoutConvenience)
            );

            // calculation on paid and pending
            let amount = paymentArr.reduce(
              (a, v) =>
                a +
                (v.payment_method !== "Online Via C2C" ? Number(v.amount) : 0),
              0
            );
            let remainingAmount = amount;
            original_appointments.forEach((app) => {
              if (
                app?.partial_amount > 0 ||
                app?.payment_method?.toLowerCase() !== "online"
              ) {
                if (app?.partial_amount > 0) {
                  let partial_remaining_amount = (
                    Number(app?.final_amount_in_rupees) -
                    Number(app?.total_paid_partial_amount)
                  ).toFixed(2);
                  app["paid_amount"] =
                    remainingAmount > partial_remaining_amount
                      ? getValueUpto2DecimalPlaces(
                          Number(app?.final_amount_in_rupees)
                        )
                      : remainingAmount > 0
                      ? getValueUpto2DecimalPlaces(
                          Number(remainingAmount) +
                            Number(app?.total_paid_partial_amount)
                        )
                      : getValueUpto2DecimalPlaces(
                          Number(app?.total_paid_partial_amount)
                        );
                  app["pending_amount"] =
                    remainingAmount > partial_remaining_amount
                      ? 0
                      : getValueUpto2DecimalPlaces(
                          Math.abs(remainingAmount - partial_remaining_amount)
                        );
                  remainingAmount =
                    remainingAmount > partial_remaining_amount
                      ? Math.abs(remainingAmount - partial_remaining_amount)
                      : 0;
                } else {
                  app["paid_amount"] =
                    remainingAmount > app?.final_amount_in_rupees
                      ? getValueUpto2DecimalPlaces(
                          Number(app?.final_amount_in_rupees)
                        )
                      : getValueUpto2DecimalPlaces(remainingAmount);
                  app["pending_amount"] =
                    remainingAmount > app?.final_amount_in_rupees
                      ? 0
                      : getValueUpto2DecimalPlaces(
                          Math.abs(
                            remainingAmount -
                              Number(app?.final_amount_in_rupees)
                          )
                        );
                  remainingAmount =
                    remainingAmount > app?.final_amount_in_rupees
                      ? Math.abs(
                          remainingAmount - Number(app?.final_amount_in_rupees)
                        )
                      : 0;
                }
              } else {
                app["paid_amount"] = app?.paid_amount
                  ? getValueUpto2DecimalPlaces(Number(app?.paid_amount))
                  : getValueUpto2DecimalPlaces(
                      Number(app?.final_amount_in_rupees)
                    );
                app["pending_amount"] = 0;
              }
            });
            added_procedure_appointments.forEach((app) => {
              if (!app?.is_deleted) {
                app["paid_amount"] =
                  remainingAmount > app?.final_amount_in_rupees
                    ? getValueUpto2DecimalPlaces(app?.final_amount_in_rupees)
                    : getValueUpto2DecimalPlaces(remainingAmount);
                app["pending_amount"] =
                  remainingAmount > app?.final_amount_in_rupees
                    ? 0
                    : getValueUpto2DecimalPlaces(
                        Math.abs(remainingAmount - app?.final_amount_in_rupees)
                      );
                remainingAmount =
                  remainingAmount > app?.final_amount_in_rupees
                    ? getValueUpto2DecimalPlaces(
                        Math.abs(remainingAmount - app?.final_amount_in_rupees)
                      )
                    : 0;
              } else {
                // app["paid_amount"] = 0;
                app["pending_amount"] = 0;
              }
            });
            setAppointmentDetails([...original_appointments]);
            setProcedureDetails([...added_procedure_appointments]);

            original_appointments.forEach((data) => {
              if (data?.booking_id) {
                if (
                  !filterAppointmentIds?.includes(data.booking_id) &&
                  data?.payment_method?.toLowerCase() === "online"
                ) {
                  filterAppointmentIds.push(data.booking_id);
                }
              } else {
                if (data?.payment_method?.toLowerCase() === "online") {
                  let amoutPaid =
                    Number(data?.total_paid_partial_amount) > 0
                      ? getValueUpto2DecimalPlaces(
                          Number(data?.total_paid_partial_amount)
                        )
                      : getValueUpto2DecimalPlaces(Number(data?.paid_amount));
                  console.log("amoutPaid", amoutPaid);
                  let obj = {
                    amount: getValueUpto2DecimalPlaces(Number(amoutPaid)),
                    payment_method: "Online Via C2C",
                    transaction_id: data?.transaction_id,
                    specify_other: false,
                    isOnline: true,
                  };
                  onlineViaC2C.push(obj);
                }
              }
            });

            if (filterAppointmentIds?.length > 0) {
              filterAppointmentIds.forEach((id) => {
                let filteredAppointment = original_appointments.filter(
                  (data) => data?.booking_id === id
                );
                if (filteredAppointment?.length > 0) {
                  let amountPaidByOnline = filteredAppointment.reduce(
                    (a, v) =>
                      a +
                      (Number(v?.total_paid_partial_amount) > 0
                        ? getValueUpto2DecimalPlaces(
                            Number(v?.total_paid_partial_amount)
                          )
                        : getValueUpto2DecimalPlaces(Number(v?.paid_amount))),
                    0
                  );
                  let obj = {
                    amount: getValueUpto2DecimalPlaces(
                      Number(amountPaidByOnline)
                    ),
                    payment_method: "Online Via C2C",
                    transaction_id: filteredAppointment[0].transaction_id,
                    specify_other: false,
                    count: filteredAppointment?.length,
                    isOnline: true,
                  };
                  onlineViaC2C.push(obj);
                  onlineAmtList.push(amountPaidByOnline);
                }
              });
            }
            let deleted_payment_list = [];
            paymentList.forEach((data) => {
              if (data.payment_method === "Online Via C2C") {
                data["is_deleted"] = true;
                deleted_payment_list.push(data);
              }
            });
            paymentArr =
              paymentList?.length > 0 ? paymentList : [{ ...PAYMENT_DETAILS }];
            let newPaymentList = [...onlineViaC2C, ...paymentArr];

            setMultiplePaymentList(newPaymentList);
            setDeletedPaymentList(deleted_payment_list);
          } else {
            C2CConsole.log("error while getting payment methods");
          }
        });
        setLoading(false);
      } else {
        setLoading(false);
        setReferenceId("");
        setReferredBy("");
      }
    });
  };

  const generateOrUpdateResourceInvoiceAPICall = () => {
    setReferenceId("");
    let procedureList = procedureDetails.filter(
      (ele) => ele.consultation_name !== ""
    );

    setLoading(true);
    // paid and pending amount calculation
    let amount = multiplePaymentList.reduce(
      (a, v) =>
        a + (v.payment_method !== "Online Via C2C" ? Number(v.amount) : 0),
      0
    );
    let remainingAmount = amount;
    appointmentDetails.forEach((app) => {
      if (
        app?.partial_amount > 0 ||
        app?.payment_method?.toLowerCase() !== "online"
      ) {
        if (app?.partial_amount > 0) {
          let partial_remaining_amount = (
            Number(app?.final_amount_in_rupees) -
            Number(app?.total_paid_partial_amount)
          ).toFixed(2);
          app["paid_amount"] =
            remainingAmount > partial_remaining_amount
              ? getValueUpto2DecimalPlaces(Number(app?.final_amount_in_rupees))
              : remainingAmount > 0
              ? getValueUpto2DecimalPlaces(
                  Number(remainingAmount) +
                    Number(app?.total_paid_partial_amount)
                )
              : getValueUpto2DecimalPlaces(
                  Number(app?.total_paid_partial_amount)
                );
          app["pending_amount"] =
            remainingAmount > partial_remaining_amount
              ? 0
              : getValueUpto2DecimalPlaces(
                  Math.abs(remainingAmount - partial_remaining_amount)
                );
          remainingAmount =
            remainingAmount > partial_remaining_amount
              ? Math.abs(remainingAmount - partial_remaining_amount)
              : 0;
        } else {
          app["paid_amount"] =
            remainingAmount > app?.final_amount_in_rupees
              ? getValueUpto2DecimalPlaces(Number(app?.final_amount_in_rupees))
              : getValueUpto2DecimalPlaces(remainingAmount);
          app["pending_amount"] =
            remainingAmount > app?.final_amount_in_rupees
              ? 0
              : getValueUpto2DecimalPlaces(
                  Math.abs(
                    remainingAmount - Number(app?.final_amount_in_rupees)
                  )
                );
          remainingAmount =
            remainingAmount > app?.final_amount_in_rupees
              ? Math.abs(remainingAmount - Number(app?.final_amount_in_rupees))
              : 0;
        }
      } else {
        app["paid_amount"] = app?.paid_amount
          ? getValueUpto2DecimalPlaces(Number(app?.paid_amount))
          : getValueUpto2DecimalPlaces(Number(app?.final_amount_in_rupees));
        app["pending_amount"] = 0;
      }
    });
    procedureList.forEach((app) => {
      if (!app?.is_deleted) {
        app["paid_amount"] =
          remainingAmount > app?.final_amount_in_rupees
            ? app?.final_amount_in_rupees
            : remainingAmount;
        app["pending_amount"] =
          remainingAmount > app?.final_amount_in_rupees
            ? 0
            : Math.abs(remainingAmount - app?.final_amount_in_rupees);
        remainingAmount =
          remainingAmount > app?.final_amount_in_rupees
            ? Math.abs(remainingAmount - app?.final_amount_in_rupees)
            : 0;
      } else {
        app["paid_amount"] = 0;
        app["pending_amount"] = 0;
      }
    });

    let originalData = {};
    appointmentDetails.forEach((app) => {
      app["referred_by"] = referredBy;
      if (app?.is_lims_booking) {
        if (originalData.hasOwnProperty(app?.appointment_id)) {
          originalData[app?.appointment_id].push(app);
        } else {
          originalData[app?.appointment_id] = [app];
        }
      } else {
        originalData[app?.appointment_id] = app;
      }
    });
    let requestPayload = {
      inclinic_payment_mode: paymentMethod == "" ? "Cash" : paymentMethod,
      doctor_id: doctor_id,
      appointment_id: appointment_id,
      staff_id: staffId,
      appointment_payment_transaction_id: edit_receipt ? appntPayTransId : null,
      original_appointment_details: originalData,
      additional_procedure_details: procedureList,
      user_id: isStaff === "staff" ? doctor_id : userId,
      ...(order_id && { order_id: order_id, clinic_id: clinicId }),
      pending_amount: getPendingAmount(),
      is_remark: isRemark,
      remark_note: remarkValue,
    };

    if (paymentMethod?.toLowerCase !== "online") {
      requestPayload["inclinic_payment_mode"] = paymentMethod;
      requestPayload["inclinic_payment_reference"] = referenceId;
    } else {
      requestPayload["inclinic_payment_reference"] = "";
    }

    let api = edit_receipt ? EDIT_RESOURCE_INVOICE : RAISE_RESOURCE_INVOICE;
    const raiseInvoiceResponse = c2cPostApiHandler(api, requestPayload);
    raiseInvoiceResponse.then(([res, err]) => {
      if (res?.data && res?.data?.statusCode === 200) {
        setLoading(false);
        setPdfReceiptData({ ...res?.data?.payload });
        setShowRaiseInvoiceDrawer(false);
        setShowReceiptPreview(true);
      } else {
        setLoading(false);
        setInvoiceUrl("");
        setFileDetails({
          fileName: "",
          fileURL: "",
          fileType: "",
        });
        setCompletionTime(null);
        setSuccessMarkModal(false);
        swal({
          title: "Sorry",
          text: res?.data?.message
            ? res?.data?.message
            : "Something Went Wrong. Please try again",
          icon: "warning",
        });
      }
    });
  };
  // Helper methods ===>

  const handleCommonCalculations = (appntDetails, procedures) => {
    let original_subtotal = appntDetails.reduce(
      (a, v) => a + v.subtotal_in_rupees,
      0
    );
    let original_discountValue = appntDetails.reduce(
      (a, v) => a + v.discount_on_consultation_fee_in_rupees,
      0
    );
    let original_discountPercent = appntDetails.reduce(
      (a, v) => a + v.discount_percent,
      0
    );
    let original_finalAmount = appntDetails.reduce(
      (a, v) => a + v.final_amount_in_rupees,
      0
    );
    let original_custom_gst_in_rupees = appntDetails.reduce(
      (a, v) => a + (!v.is_deleted ? v.custom_gst_in_rupees : 0),
      0
    );

    setTotalConsultationFees(
      parseFloat(
        (
          procedures.reduce((a, v) => a + v.subtotal_in_rupees, 0) +
          original_subtotal
        )?.toFixed(2)
      )
    );
    setTotalFees(
      getValueUpto2DecimalPlaces(
        procedures.reduce((a, v) => a + v.final_amount_in_rupees, 0) +
          original_finalAmount
      )
    );
    let byCashAndPartialPayedAppointments = appntDetails.filter(
      (app) =>
        app.partial_amount != 0 ||
        app.payment_method === "Paid at Clinic - By Cash"
    );
    let consultation_fees =
      procedures.reduce((a, v) => a + v.final_amount_in_rupees, 0) +
      (byCashAndPartialPayedAppointments?.length > 0
        ? byCashAndPartialPayedAppointments?.reduce(
            (a, v) => a + Number(v.final_amount_in_rupees),
            0
          )
        : 0);
    let totalPaidPartialAmt = appntDetails.reduce(
      (a, v) => a + v.total_paid_partial_amount,
      0
    );
    let amountPayed =
      multiplePaymentList.reduce(
        (a, v) =>
          a +
          (v.isSave && v.payment_method !== "Online Via C2C" && v.amount
            ? Number(v.amount)
            : 0),
        0
      ) + Number(totalPaidPartialAmt);
    setTotalPendingAmount(
      parseFloat((consultation_fees - amountPayed)?.toFixed(2))
    );
    setDiscountAtClinic(
      procedures.reduce(
        (a, v) => a + v.discount_on_consultation_fee_in_rupees,
        0
      ) + original_discountValue
    );
    setInputValue(
      procedures.reduce((a, v) => a + v.discount_percent, 0) +
        original_discountPercent
    );
    setTotalCustomGst(
      getValueUpto2DecimalPlaces(
        procedures.reduce(
          (a, v) => a + (!v.is_deleted ? v.custom_gst_in_rupees : 0),
          0
        ) + original_custom_gst_in_rupees
      )
    );
  };

  const getPendingAmount = () => {
    let calculatedAmount = multiplePaymentList.reduce(
      (a, v) =>
        a +
        (!v.isSave &&
        v.payment_method !== "" &&
        v.payment_method !== "Online Via C2C" &&
        v.amount
          ? Number(v.amount)
          : 0),
      0
    );
    let calculatedPendingAmount = parseFloat(
      (totalPendingAmount - calculatedAmount).toFixed(2)
    );
    return calculatedPendingAmount > 0 ? calculatedPendingAmount : 0;
  };

  // <===

  // Actions ⇒.

  const onRaiseInvoiceClose = () => {
    history.goBack();
    setDisconnectWebSocket(true);
  };

  const addNewProcedure = () => {
    setProcedureDetails([...procedureDetails, DEFAULT_PROCEDURE_DETAILS]);
    setHidePaymentMethod(false);
  };

  const deleteProcedure = (index) => {
    let procedureList = [...procedureDetails];

    if (procedureList[index].check_in_id) {
      procedureList[index].is_deleted = true;
      procedureList[index].paid_amount = 0;
      procedureList[index].pending_amount = 0;
      let tempFinalAmount =
        procedureList[index].total_fee_in_rupees +
        procedureList[index].custom_gst_in_rupees;
      applyRefund(null, index, tempFinalAmount);
    } else {
      setDiscountAtClinic(
        discountAtClinic -
          procedureList[index].discount_on_consultation_fee_in_rupees
      );
      setInputValue(inputValue - procedureList[index].discount_percent);
      setTotalRefund(totalRefund - procedureList[index].refund_in_rupees);

      setTotalConsultationFees(
        parseFloat(
          (
            totalConsultationFees - procedureList[index].subtotal_in_rupees
          ).toFixed(2)
        )
      );
      setTotalPendingAmount(
        parseFloat(
          (
            totalPendingAmount -
            parseFloat(procedureList[index].final_amount_in_rupees?.toFixed(2))
          ).toFixed(2)
        )
      );
      setTotalFees(
        getValueUpto2DecimalPlaces(
          totalFees -
            parseFloat(procedureList[index].final_amount_in_rupees.toFixed(2))
        )
      );
      setTotalCustomGst(
        getValueUpto2DecimalPlaces(
          totalCustomGst - procedureList[index].custom_gst_in_rupees
        )
      );
      procedureList.splice(index, 1);
      // setProcedureDetails([...procedureList]);
      adjustPaidAndPendingOnAddProcedure(
        procedureList,
        multiplePaymentList,
        appointmentDetails
      );
    }

    checkToHidePaymentMethod(appointmentDetails, procedureList);

    if (procedureList.length - 1 !== 0) {
    } else {
      if (!hasPartialAmount) {
        setPaymentMethod("online");
      }
    }
  };

  const checkToHidePaymentMethod = (
    originalAppointmentList,
    addedAppointments = []
  ) => {
    let hasPartialAmountOrCashPayment = originalAppointmentList.filter(
      (data) =>
        data?.payment_method === "Paid at Clinic - By Cash" ||
        +data?.partial_amount > 0
    );
    setHidePaymentMethod(
      hasPartialAmountOrCashPayment?.length === 0 &&
        addedAppointments &&
        addedAppointments?.length === 0
    );
  };

  const checkPartialAmount = (originalAppointmentList) => {
    let hasPertialAppointment = originalAppointmentList?.filter(
      (data) => +data?.partial_amount > 0
    );
    setHasPartialAmount(hasPertialAppointment?.length > 0);
  };

  const handleSubmit = () => {
    addMultiplePaymentAPICall();
  };

  const handleConsultationType = (procedureValue, index) => {
    let requestPayload = {
      doctor_id: doctor_id,
      consultation_type: procedureValue.value,
      staff_id: `${isStaff === "staff" ? staffId : ""}`,
      clinic_id: clinicId,
      ...(procedureValue?.value === "4" && {
        procedure_id: procedureValue?.id,
      }),
    };
    setLoading(true);
    const procedureDetailsResponse = c2cPostApiHandler(
      GET_PROCEDURE_DETAILS_BY_ID,
      requestPayload
    );
    procedureDetailsResponse.then(([res, err]) => {
      if (!err && res.data.statusCode == 200) {
        let consultation_type_value;
        if (res.data.data.consultation_type === "regular") {
          consultation_type_value = 5;
        } else if (res.data.data.consultation_type === "followup") {
          consultation_type_value = 6;
        } else {
          consultation_type_value = 4;
        }
        let procedureList = [...procedureDetails];

        let sgst = res.data.data.sgst_percent
          ? parseFloat((+res.data.data.sgst_percent)?.toFixed(2))
          : 0;
        let cgst = res.data.data.cgst_percent
          ? parseFloat((+res.data.data.cgst_percent)?.toFixed(2))
          : 0;

        let custom_gst_in_rupees =
          res.data.data.subtotal_in_rupees * ((+sgst + +cgst) / 100);
        let final_amount_in_rupees =
          res.data.data.subtotal_in_rupees + custom_gst_in_rupees;

        procedureList[index] = {
          ...procedureList[index],
          cgst_percent: cgst,
          custom_gst_in_rupees: custom_gst_in_rupees,
          consultation_fee_in_rupees: res.data.data.fee_in_rupees,
          consultation_name: res.data.data.consultation_type,
          consultation_type: consultation_type_value,
          convenience_fee_in_rupees: 0,
          discount_on_consultation_fee_in_rupees: 0,
          discount_percent: 0,
          fee_in_rupees: res.data.data.fee_in_rupees,
          gst_in_rupees: 0,
          igst_percent: res.data.data.igst_percent
            ? res.data.data.igst_percent
            : 0,
          inputValue: 0,
          procedure_id: res.data.data.procedure_id,
          procedure_name: res.data.data.procedure_name,
          sgst_percent: sgst,
          subtotal_in_rupees: res.data.data.subtotal_in_rupees,
          total_fee_in_rupees: res.data.data.subtotal_in_rupees,
          doctor_commission_percentage:
            procedureValue?.doctor_commission_percentage,
          referral_percentage: !isCompleted
            ? procedureValue?.referral_percentage
            : "0",
          refund_in_rupees: 0,
          final_amount_in_rupees: final_amount_in_rupees,
          partial_with_convenience_fee: 0,
          pending_amount: res.data.data.fee_in_rupees,
        };

        adjustPaidAndPendingOnAddProcedure(
          procedureList,
          multiplePaymentList,
          appointmentDetails
        );

        // setProcedureDetails([...procedureList]);

        handleCommonCalculations(appointmentDetails, procedureList);

        if (paymentMethod === "online") {
          setPaymentMethod("Cash");
        }
        setLoading(false);
      } else {
        setLoading(false);
      }
    });
  };

  function applyDiscount(e, index) {
    let value = e.target.value
      ? Number(e.target.value.replace("%", "").trim())
      : 0;
    if (value <= 100) {
      let payableFee = procedureDetails[index].fee_in_rupees;
      let inputValue1 = value ? Number(value) : 0;
      let newFee = payableFee * (inputValue1 / 100);
      let lowerLimitFloat = Number(newFee).toFixed(2);
      let lowerLimit = parseFloat(lowerLimitFloat);
      const finalCost = newFee > lowerLimit ? newFee : lowerLimit;
      let totalFee =
        inputValue1 !== null
          ? getValueUpto2DecimalPlaces(payableFee - finalCost)
          : payableFee;
      let customGst =
        (+procedureDetails[index].sgst_percent +
          +procedureDetails[index].cgst_percent) /
        100;
      let customGstInRupees = Number(totalFee) * customGst;
      let finalAmount =
        customGstInRupees +
        (Number(totalFee) - Number(procedureDetails[index].refund_in_rupees));
      if (procedureDetails[index]["refund_in_rupees"] <= totalFee) {
        procedureDetails[index]["fee_in_rupees"] = payableFee;
        procedureDetails[index]["total_fee_in_rupees"] = totalFee;
        procedureDetails[index]["discount_on_consultation_fee_in_rupees"] =
          parseFloat(finalCost.toFixed(2));
        procedureDetails[index]["discount_percent"] = inputValue1;

        procedureDetails[index]["final_amount_in_rupees"] = parseFloat(
          finalAmount.toFixed(2)
        );
        procedureDetails[index]["pending_amount"] = parseFloat(
          finalAmount.toFixed(2)
        );
        procedureDetails[index].custom_gst_in_rupees = customGstInRupees;
        // setProcedureDetails(procedureDetails);
        handleCommonCalculations(appointmentDetails, procedureDetails);

        let prope = e.target.attributes.column.value; // the custom column attribute
        let indexing = e.target.attributes.index.value; // index of state array -rows
        let fieldValue = e.target.value; // value

        const tempRows = [...procedureDetails]; // avoid direct state mutation
        const tempObj = procedureDetails[indexing]; // copy state object at index to a temporary object
        tempObj["inputValue"] = fieldValue; // modify temporary object
        tempObj[prope] = fieldValue;

        tempRows[indexing] = tempObj;
        // setProcedureDetails(tempRows);
        adjustPaidAndPendingOnAddProcedure(
          tempRows,
          multiplePaymentList,
          appointmentDetails
        );
      } else {
        alert("Refund cannot be more than total amount");
      }
    } else {
      alert("More than 100%");
    }
  }

  function applyFee(e, index) {
    let payableFee = e.target.value ? Number(e.target.value) : 0;
    let inputValue1 = procedureDetails[index].discount_percent
      ? procedureDetails[index].discount_percent
      : 0;
    let newFee = payableFee * (inputValue1 / 100);
    let lowerLimitFloat = Number(newFee).toFixed(2);
    let lowerLimit = parseFloat(lowerLimitFloat);
    const finalCost = newFee > lowerLimit ? newFee : lowerLimit;
    let totalFee =
      inputValue1 !== null
        ? getValueUpto2DecimalPlaces(payableFee - finalCost)
        : payableFee;
    let customGst =
      (+procedureDetails[index].sgst_percent +
        +procedureDetails[index].cgst_percent) /
      100;
    let customGstInRupees = Number(totalFee) * customGst;
    let finalAmount =
      customGstInRupees +
      (Number(totalFee) - Number(procedureDetails[index].refund_in_rupees));
    if (procedureDetails[index]["refund_in_rupees"] <= totalFee) {
      procedureDetails[index].fee_in_rupees = payableFee;
      procedureDetails[index].subtotal_in_rupees = payableFee;
      procedureDetails[index]["total_fee_in_rupees"] = totalFee;
      procedureDetails[index]["final_amount_in_rupees"] = parseFloat(
        finalAmount.toFixed(2)
      );
      procedureDetails[index]["pending_amount"] = parseFloat(
        finalAmount.toFixed(2)
      );
      procedureDetails[index]["discount_on_consultation_fee_in_rupees"] =
        parseFloat(finalCost.toFixed(2));
      procedureDetails[index]["discount_percent"] = inputValue1;
      procedureDetails[index]["consultation_fee_in_rupees"] = payableFee;
      procedureDetails[index].custom_gst_in_rupees = customGstInRupees;

      // setProcedureDetails(procedureDetails);
      adjustPaidAndPendingOnAddProcedure(
        procedureDetails,
        multiplePaymentList,
        appointmentDetails
      );

      handleCommonCalculations(appointmentDetails, procedureDetails);
    } else {
      alert("Refund cannot be more than total amount");
    }
  }

  function applyRefund(e, index, val) {
    let newValue = e?.target?.value ? Number(e.target.value) : val ?? 0;
    let tempFinalAmount =
      procedureDetails[index]?.total_fee_in_rupees +
      procedureDetails[index]?.custom_gst_in_rupees;
    if (newValue <= Number(tempFinalAmount)) {
      let refund = 0;
      let customGst =
        (+procedureDetails[index].sgst_percent +
          +procedureDetails[index].cgst_percent) /
        100;
      let customGstInRupees =
        (Number(procedureDetails[index].subtotal_in_rupees) -
          Number(
            procedureDetails[index].discount_on_consultation_fee_in_rupees
          )) *
        customGst;
      let finalAmount =
        customGstInRupees +
        (Number(procedureDetails[index].subtotal_in_rupees) -
          Number(
            procedureDetails[index].discount_on_consultation_fee_in_rupees
          ) -
          Number(newValue));
      procedureDetails[index].refund_in_rupees = newValue;
      procedureDetails[index].final_amount_in_rupees = parseFloat(
        finalAmount.toFixed(2)
      );
      procedureDetails[index].pending_amount = parseFloat(
        finalAmount.toFixed(2)
      );
      procedureDetails[index].custom_gst_in_rupees = customGstInRupees;
      procedureDetails.forEach((pr) => {
        refund += pr.refund_in_rupees ? pr.refund_in_rupees : 0;
      });
      let original_refundValue = appointmentDetails.reduce(
        (a, v) => a + v.refund_in_rupees,
        0
      );
      // setProcedureDetails([...procedureDetails]);
      adjustPaidAndPendingOnAddProcedure(
        procedureDetails,
        multiplePaymentList,
        appointmentDetails
      );

      setTotalRefund(Number(refund + original_refundValue));
      handleCommonCalculations(appointmentDetails, procedureDetails);
    } else {
      alert("Refund cannot be more than total amount");
    }
  }

  function applyDefaultFee(e, index) {
    let feeValue = e.target.value ? Number(e.target.value) : 0;
    let appntDetails = appointmentDetails;
    let byCash =
      appointmentDetails[index].payment_method === "Paid at Clinic - By Cash";
    let refundAmount = appntDetails[index].refund_in_rupees;
    let discount = appntDetails[index].discount_percent;
    let value = discount ?? 0;
    let newFee = feeValue * (value / 100);
    let lowerLimitFloat = Number(newFee).toFixed(2);
    let lowerLimit = parseFloat(lowerLimitFloat);
    const finalCost = newFee > lowerLimit ? newFee : lowerLimit;
    let total =
      value !== null
        ? getValueUpto2DecimalPlaces(feeValue - finalCost)
        : feeValue;
    let customGst =
      (+appntDetails[index].sgst_percent + +appntDetails[index].cgst_percent) /
      100;
    let customGstInRupees = Number(total) * customGst;
    let finalAmount =
      customGstInRupees + (Number(total) - Number(refundAmount ?? 0));
    if (refundAmount <= Number(total)) {
      appntDetails[index].fee_in_rupees = feeValue;
      appntDetails[index].subtotal_in_rupees = feeValue;
      appntDetails[index].total_fee_in_rupees = total;
      appntDetails[index].custom_gst_in_rupees = customGstInRupees;
      appntDetails[index].discount_on_consultation_fee_in_rupees = parseFloat(
        finalCost.toFixed(2)
      );
      appntDetails[index].consultation_fee_in_rupees = byCash
        ? feeValue
        : appntDetails[index].consultation_fee_in_rupees;
      appntDetails[index].final_amount_in_rupees = parseFloat(
        finalAmount.toFixed(2)
      );
      appntDetails[index].pending_amount = parseFloat(finalAmount.toFixed(2));
      setAppointmentDetails(appntDetails);
      handleCommonCalculations(appntDetails, procedureDetails);
      adjustPaidAndPendingOnAddProcedure(
        procedureDetails,
        multiplePaymentList,
        appntDetails
      );
    } else {
      alert("Refund cannot be more than total amount");
    }
  }

  function applyDefaultDiscount(e, index) {
    let value = e.target.value
      ? Number(e.target.value.replace("%", "").trim())
      : 0;
    let appntDetails = appointmentDetails;
    let refundAmount = appntDetails[index].refund_in_rupees;
    let fee = appntDetails[index].fee_in_rupees;
    if (value <= 100) {
      let newFee = fee * (value / 100);
      let lowerLimitFloat = Number(newFee).toFixed(2);
      let lowerLimit = parseFloat(lowerLimitFloat);
      const finalCost = newFee > lowerLimit ? newFee : lowerLimit;
      let total =
        value !== null ? getValueUpto2DecimalPlaces(fee - finalCost) : fee;
      let customGst =
        (+appntDetails[index].sgst_percent +
          +appntDetails[index].cgst_percent) /
        100;
      let customGstInRupees = Number(total) * customGst;
      let finalAmount =
        customGstInRupees + (Number(total) - Number(refundAmount ?? 0));
      if (refundAmount <= Number(total)) {
        appntDetails[index].discount_percent = value;
        appntDetails[index].total_fee_in_rupees = total;
        appntDetails[index].custom_gst_in_rupees = customGstInRupees;
        appntDetails[index].discount_on_consultation_fee_in_rupees = parseFloat(
          finalCost.toFixed(2)
        );
        appntDetails[index].final_amount_in_rupees = parseFloat(
          finalAmount.toFixed(2)
        );
        appntDetails[index].pending_amount = parseFloat(finalAmount.toFixed(2));
        handleCommonCalculations(appntDetails, procedureDetails);
        adjustPaidAndPendingOnAddProcedure(
          procedureDetails,
          multiplePaymentList,
          appntDetails
        );
      } else {
        alert("Refund cannot be more than total amount");
      }
    } else {
      alert("More than 100%");
    }
  }

  function applyDefaultRefund(e, index) {
    let refundValue = e.target.value ? Number(e.target.value) : 0;
    let appntDetails = appointmentDetails;
    let paidAmount = appntDetails[index].fee_in_rupees;
    let discountAmount =
      appntDetails[index].discount_on_consultation_fee_in_rupees;

    if (refundValue <= Number(paidAmount) - Number(discountAmount)) {
      let refund = 0;
      let customGst =
        (+appntDetails[index].sgst_percent +
          +appntDetails[index].cgst_percent) /
        100;
      let customGstInRupees =
        (Number(paidAmount ?? 0) - Number(discountAmount)) * customGst;
      let finalAmount =
        customGstInRupees +
        (Number(paidAmount ?? 0) -
          Number(refundValue) -
          Number(discountAmount));
      procedureDetails.forEach((pr) => {
        refund += pr.refund_in_rupees ? pr.refund_in_rupees : 0;
      });
      appntDetails[index].refund_in_rupees = refundValue;
      appntDetails[index].custom_gst_in_rupees = customGstInRupees;
      appntDetails[index].final_amount_in_rupees = parseFloat(
        finalAmount.toFixed(2)
      );
      appntDetails[index].pending_amount = parseFloat(finalAmount.toFixed(2));
      let original_refundValue = appointmentDetails.reduce(
        (a, v) => a + v.refund_in_rupees,
        0
      );
      setTotalRefund(refund + original_refundValue);
      handleCommonCalculations(appntDetails, procedureDetails);
      adjustPaidAndPendingOnAddProcedure(
        procedureDetails,
        multiplePaymentList,
        appntDetails
      );
    } else {
      alert("Refund cannot be more than total amount");
    }
  }

  const adjustPaidAndPendingOnAddProcedure = (
    procedureList,
    paymentlist,
    appointmentDetails
  ) => {
    let list = paymentlist ? paymentlist : multiplePaymentList;
    let payedAmount = list?.reduce(
      (a, v) =>
        a +
        (v?.payment_method !== "Refund" &&
        v?.payment_method !== "Online Via C2C"
          ? Number(v.amount)
          : 0),
      0
    );

    let tempRemainingAmount = payedAmount;
    appointmentDetails.forEach((app) => {
      if (
        app?.partial_amount > 0 ||
        app?.payment_method?.toLowerCase() !== "online"
      ) {
        if (app?.partial_amount > 0) {
          let partial_remaining_amount = (
            Number(app?.final_amount_in_rupees) -
            Number(app?.total_paid_partial_amount)
          ).toFixed(2);
          app["paid_amount"] =
            tempRemainingAmount > partial_remaining_amount
              ? getValueUpto2DecimalPlaces(Number(app?.final_amount_in_rupees))
              : tempRemainingAmount > 0
              ? getValueUpto2DecimalPlaces(
                  Number(tempRemainingAmount) +
                    Number(app?.total_paid_partial_amount)
                )
              : getValueUpto2DecimalPlaces(
                  Number(app?.total_paid_partial_amount)
                );
          app["pending_amount"] =
            tempRemainingAmount > partial_remaining_amount
              ? 0
              : getValueUpto2DecimalPlaces(
                  Math.abs(tempRemainingAmount - partial_remaining_amount)
                );
          tempRemainingAmount =
            tempRemainingAmount > partial_remaining_amount
              ? Math.abs(tempRemainingAmount - partial_remaining_amount)
              : 0;
        } else {
          app["paid_amount"] =
            tempRemainingAmount > app?.final_amount_in_rupees
              ? getValueUpto2DecimalPlaces(Number(app?.final_amount_in_rupees))
              : getValueUpto2DecimalPlaces(tempRemainingAmount);
          app["pending_amount"] =
            tempRemainingAmount > app?.final_amount_in_rupees
              ? 0
              : getValueUpto2DecimalPlaces(
                  Math.abs(
                    tempRemainingAmount - Number(app?.final_amount_in_rupees)
                  )
                );
          tempRemainingAmount =
            tempRemainingAmount > app?.final_amount_in_rupees
              ? Math.abs(
                  tempRemainingAmount - Number(app?.final_amount_in_rupees)
                )
              : 0;
        }
      } else {
        app["paid_amount"] = app?.paid_amount
          ? getValueUpto2DecimalPlaces(Number(app?.paid_amount))
          : getValueUpto2DecimalPlaces(Number(app?.final_amount_in_rupees));
        app["pending_amount"] = 0;
      }
    });
    setAppointmentDetails([...appointmentDetails]);

    procedureList.forEach((procedure) => {
      if (!procedure?.is_deleted) {
        procedure["paid_amount"] =
          tempRemainingAmount > procedure?.final_amount_in_rupees
            ? getValueUpto2DecimalPlaces(
                Number(procedure?.final_amount_in_rupees)
              )
            : getValueUpto2DecimalPlaces(tempRemainingAmount);
        procedure["pending_amount"] =
          tempRemainingAmount > procedure?.final_amount_in_rupees
            ? 0
            : getValueUpto2DecimalPlaces(
                Math.abs(
                  tempRemainingAmount -
                    Number(procedure?.final_amount_in_rupees)
                )
              );

        tempRemainingAmount =
          tempRemainingAmount > procedure?.final_amount_in_rupees
            ? Math.abs(tempRemainingAmount - procedure?.final_amount_in_rupees)
            : 0;
      }
    });
    setProcedureDetails([...procedureList]);
  };

  const printReceipt = () => {
    setSuccessMarkModal(false);
    setDocumentShow(true);
  };

  const getClassName = (isPendingView, isMobile) => {
    if (isPendingView) {
      return isMobile ? "ri-full-width" : "ri-partial-width";
    }
    return "ri-full-width";
  };

  const closeNotification = () => {
    setDocumentShow(false);
    setFileDetails({
      fileName: "",
      fileURL: "",
      fileType: `${fileDetails?.fileType}`,
    });
    // refreshAppointmentsMethod();
  };

  const updateMultiplePaymentList = (list) => {
    let tempPayemntList = [...list, ...deletedPaymentList];
    setMultiplePaymentList(tempPayemntList);
    adjustPaidAndPendingOnAddProcedure(
      procedureDetails,
      tempPayemntList,
      appointmentDetails
    );
  };

  const handleReset = () => {
    setMultiplePaymentList([]);
    setProcedureDetails([]);
    setReferenceId("");
    setPaymentMethod("");
    setTotalRefund(0);
    setDiscountAtClinic(0);
    setHasPartialAmount(false);
    setTotalAmountPaid(0);
    setReferredBy("");
  };

  const handleReferredByChange = (e) => {
    setReferredBy(e.target.value);
  };

  const handleClosePdfPreview = () => {
    onRaiseInvoiceClose();
  };

  const handleReceiptRemark = (event) => {
    setRemarkValue(event.target.value);
  };

  const handleOnClickToggleBtn = () => {
    setIsRemark(!isRemark);
  };

  const raiseInvoiceRemarkUI = () => {
    return (
      <div className="refund-remark-wrapper">
        <div className="rr-title-btn-cont">
          <p className="rr-title">Remark</p>
          <div className="rr-toggle-btn">
            <p className="rr-btn-title">Print remark in receipt</p>
            <CustomToggleButton
              selected={isRemark}
              deselectedLabel="No"
              selectedLabel="Yes"
              handleOnClick={handleOnClickToggleBtn}
            />
          </div>
        </div>
        <input
          className="rr-remark-input"
          placeholder="Type remark up to 80 characters"
          maxLength={80}
          value={remarkValue}
          onChange={handleReceiptRemark}
        />
      </div>
    );
  };

  // create UI ⇒

  const raiseInvoiceUI = () => {
    return (
      <div className="raise-invoice-container">
        <div className="raise-invoice-wrapper">
          <div className={getClassName(isPendingView, isMobile)}>
            <div className="raise-invoice-patient-details-wrapper">
              <RaiseInvoiceHeader onRaiseInvoiceClose={onRaiseInvoiceClose} />
            </div>
            {isMobile && (
              <PendingAmountContainer
                appointment={appointment}
                disconnectWebSocket={disconnectWebSocket}
                setIsPendingView={setIsPendingView}
              />
            )}
            <div className="raise-invoice-details-container">
              <PatientDetails
                patientDetails={patientDetails}
                referredBy={referredBy}
                handleReferredByChange={handleReferredByChange}
              />

              <ConsultationDetails
                appointmentDetails={appointmentDetails}
                consultationOptions={consultationOptions}
                procedureDetails={procedureDetails}
                deleteProcedure={deleteProcedure}
                addNewProcedure={addNewProcedure}
                handleConsultationType={handleConsultationType}
                applyRefund={applyRefund}
                applyDiscount={applyDiscount}
                applyFee={applyFee}
                applyDefaultFee={applyDefaultFee}
                applyDefaultDiscount={applyDefaultDiscount}
                applyDefaultRefund={applyDefaultRefund}
              />
              <PaymentMenthods
                hidePaymentMode={hidePaymentMode}
                multiplePaymentList={multiplePaymentList}
                totalPendingAmount={totalPendingAmount}
                totalAmountPaid={totalAmountPaid}
                totalFees={totalFees}
                hasPartialAmount={hasPartialAmount}
                totalPaidPartialAmount={totalPaidPartialAmount}
                totalPaidFullAmount={totalPaidFullAmount}
                appointmentDetails={appointmentDetails}
                updateMultiplePaymentList={updateMultiplePaymentList}
              />
              <PaymentSummary
                appointmentDetails={appointmentDetails}
                totalRefund={totalRefund}
                discountAtClinic={discountAtClinic}
                inputValue={inputValue}
                totalFees={totalFees}
                totalConsultationFees={totalConsultationFees}
                totalPendingAmount={totalPendingAmount}
                totalAmountPaid={totalAmountPaid}
                hasPartialAmount={hasPartialAmount}
                totalPaidPartialAmount={totalPaidPartialAmount}
                totalGST={totalGST}
                totalConvenience={totalConvenience}
                totalPaidFullAmount={totalPaidFullAmount}
                totalPartialAmountWithoutConvenience={
                  totalPartialAmountWithoutConvenience
                }
                totalCustomGst={totalCustomGst}
              />
              {raiseInvoiceRemarkUI()}
            </div>

            <RaiseInvoiceFooter
              totalFees={totalFees}
              isPendingView={isPendingView}
              disableSubmit={disableSubmit || loading}
              handleSubmit={handleSubmit}
            />
          </div>

          {!isMobile && (
            <PendingAmountContainer
              appointment={appointment}
              disconnectWebSocket={disconnectWebSocket}
              setIsPendingView={setIsPendingView}
            />
          )}
        </div>
      </div>
    );
  };

  const renderDocument = (width) => {
    if (documentShow) {
      return (
        <DocumentContainer
          cancelHandler={() => closeNotification()}
          url={`${fileDetails?.fileURL}`}
          fileName={fileDetails?.fileName}
          fileType={fileDetails?.fileType}
          width={width || ""}
        />
      );
    }
  };
  return (
    <div>
      {loading ? <Loader /> : ""}
      {raiseInvoiceUI()}
      {renderDocument("98%")}
      {showSuccessMarkModal && (
        <MarkCheckInSuccessModal
          appointmentDetails={patientDetails}
          openView={showSuccessMarkModal}
          invoiceUrl={invoiceUrl}
          completionTime={completionTime}
          printInvoice={printReceipt}
          dashboardRaiseInvoiceSuccessModal={true}
          // closeView={() => {
          //   setShowRaiseInvoiceDrawer(false);
          //   setSuccessMarkModal(false);
          //   refreshAppointmentsMethod();
          // }}
        />
      )}
      {showReceiptPreview && (
        <RaiseInvoicePDFView
          pdfReceiptData={pdfReceiptData}
          handleClosePdfPreview={handleClosePdfPreview}
          user_id={user_id}
          clinic_id={clinic_id}
          staff_id={staff_id}
          user_type={user_type}
          appointment={appointment}
        />
      )}
    </div>
  );
};

//export
export default RaiseInvoice;
